import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { currentStageData, setIsToolsHeight, setIsSidebar } from '../store/slice/currentStageSlice';
import { setFeatureTable } from '../store/slice/bufferSlice';
import GisApiServices from '../services/GisApiServices';
import { setPermissionsData } from '../store/slice/permissionSlice';

const Sidebar = () => {
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const dispatch = useDispatch();
  const [isGetPermission, setIsGetPermission] = useState([]);
  const navigate = useNavigate();
  const { isWidth, isTheme, isSideBar, isToolHeight } = useSelector((state) => state.currentStage);
  const authData = useSelector((state) => state.authToken.authData);
  const [isVisitorCoun, setIsVisitorCoun] = useState();

  const fetchUserPermission = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }

      const value = { role_Id: authData?.RoleID };

      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await GisApiServices.userPermissions(value, config);
      const getPermission = response.data?.data || [];
      setIsGetPermission(getPermission?.permissions);
      dispatch(setPermissionsData(response.data?.data));
    } catch (error) {
      console.error("Error fetching user roles", error);
    }
  };

  useEffect(() => {
    fetchUserPermission();
    fetchModule();
  }, []);

  const handleClick = (item) => {
    if (item.text === "GIS Dashboard" && location.pathname === "/dashboard") {
      dispatch(currentStageData(0));
      dispatch(setIsToolsHeight(!isToolHeight));
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setIsSidebarClosed(isWidth);
  }, [isWidth]);

  useEffect(() => {
    dispatch(setIsSidebar(location.pathname === "/user-chatbot" || location.pathname === "/misdashboard" || location.pathname === "/link-dashboard" || location.pathname === "/SCADAHome"));
    dispatch(setFeatureTable([]));
  }, [location, dispatch]);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      dispatch(currentStageData(0));
      dispatch(setIsToolsHeight(false));
    }
  }, [location.pathname]);

  const toggleNav = () => {
    dispatch(setIsSidebar(!isSideBar));
    setIsSidebarClosed(!isSideBar);
  };

  const navigationItems = [
    {
      icon: "img/misicon.png",
      text: 'MIS Dashboard',
      href: '/misdashboard',
      active: "img/misactive.svg"
    },
    {
      icon: "img/misicon.png",
      text: 'Integrated Dashboard',
      href: '/link-dashboard',
      active: "img/misactive.svg"
    },
    {
      icon: "img/gisactive.svg",
      text: 'GIS Dashboard',
      href: '/dashboard',
      active: "img/Rectangleiconloc.png"
    },
    {
      icon: "img/ai-garud-white.png",       // inactive
      text: 'GARUD AI',
      href: '/user-chatbot',
      active: "img/ai-garud-logo.png"       // active
    },
    {
      icon: "img/activity.png",
      text: 'Activities',
      href: '/activities',
      active: "img/activityactive.svg"
    },
    {
      icon: "img/datamange.png",
      text: 'Data Management',
      href: '/datamanagement',
      active: "img/dataactive.svg"
    },
    {
      icon: "img/acces.png",
      text: 'Access & Security',
      href: '/security',
      active: "img/accesactive.svg"
    },
    {
      icon: "img/acces.png",
      text: 'Change Password',
      href: '/change-password',
      active: "img/accesactive.svg"
    },
  ];

  const moduleMap = {
    'MIS Dashboard': 'M2',
    'GIS Dashboard': 'M1',
    'Activities': 'M3',
    'Data Management': 'M4',
    'Access & Security': 'M5',
    'GARUD AI': 'M6',
    // 'Settings': 'M7',
    // 'Change Password': 'M7',
     'Integrated Dashboard': 'M7',
  };

  const userModuleIdSet = new Set(isGetPermission?.map(p => p.moduleId));

  const filteredNavigationItems = navigationItems.filter(item => {
    const moduleId = moduleMap[item.text];
    return moduleId && userModuleIdSet.has(moduleId);
  });

  console.log("filteredNavigationItems", filteredNavigationItems);

  const fetchModule = async () => {
    try {
      const authToken = localStorage.getItem('token');
      if (!authToken) {
        console.error("No auth token found");
        navigate("/login");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await GisApiServices.GetUserVisitCount(config);
      setIsVisitorCoun(response?.data?.totalRecords);
    } catch (error) {
      console.error("Error fetching module data", error);
    }
  };

  return (
    <div
      className={`
        transition-all duration-300 ease-in-out sidebar-dashboard
        position-relative 
        ${isSideBar ? 'w-20' : 'sidebar-in'}
        ${isMobile ? (isSideBar ? 'w-0' : 'absolute left-0 top-0 w-64') : ''}
      `}
    >
      <div className={isSideBar ? "d-flex justify-content-center" : "sidebarmenudiv"}>
        <h3 className={`sidebarbuttontitle m-0 ${isSideBar ? 'd-none' : 'block'}`}>Menu</h3>
        <button onClick={toggleNav} className="toggle-button" aria-label="Toggle Sidebar">
          <img
            src="img/Vectortoggle.png"
            alt='toggle'
            style={{ rotate: isSideBar ? '180deg' : '360deg', width: "20px", height: "20px" }}
          />
        </button>
      </div>

      <nav className="postion-relative dashboard mt-3">
        {filteredNavigationItems.map((item, index) => (
          <Link
            key={index}
            to={item.href}
            className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
            onClick={() => handleClick(item)}
          >
            {/* Normal sidebar icon (active/deactive) */}
            {location.pathname === item.href ? (
              <img src={item.active} alt={item.text} height="20px" width="20px" />
            ) : (
              <img src={item.icon} alt={item.text} height="20px" width="20px" />
            )}

            {/* Text + GARUD AI special tab image */}
            <span
              className={`ml-3 transition-opacity duration-300 link-text ${isSideBar ? 'opacity-0 d-none' : 'opacity-100 inline'
                }`}
            >

              {item.text === "GARUD AI" ? (
                <img
                  src={
                    location.pathname === item.href
                      ? "img/garud-menu-tab.svg"   // active
                      : "img/menu-tab-white.svg"  // inactive
                  }
                  alt="GARUD AI Tab"
                  style={{ height: "28px" }}
                />
              ) : item.text}
            </span>
          </Link>
        ))}

        <div className={!isSideBar ? 'sidebarbuttondiv' : 'd-none'}>
          <h5 className='sidebarbuttontitle '>Total Visitors</h5>
          <h5 className='sidebarbuttontitle mb-4'>{isVisitorCoun}</h5>
          <h6 className='sidebarbuttontitle'>Disclaimer</h6>
          <p className='sidebarpara m-0'>
            The data and analyses provided by this platform are for informational purposes only.
            While every effort is made to ensure the accuracy and reliability of the information,
            the platform and its providers do not guarantee its completeness or suitability for specific applications.
          </p>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
